var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBank(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.26557 0.832408C6.47863 0.681132 6.73562 0.599609 6.99943 0.599609C7.26325 0.599609 7.52024 0.681132 7.7333 0.832408L13.0105 4.57733C13.7052 5.06965 13.3475 6.13795 12.4885 6.14002H1.50966C0.650634 6.13795 0.293656 5.06965 0.9877 4.57733L6.26486 0.832408H6.26557ZM7.71055 3.54637C7.71055 3.36299 7.63562 3.18711 7.50227 3.05744C7.36891 2.92776 7.18803 2.85492 6.99943 2.85492C6.81084 2.85492 6.62996 2.92776 6.4966 3.05744C6.36324 3.18711 6.28832 3.36299 6.28832 3.54637C6.28832 3.72976 6.36324 3.90563 6.4966 4.0353C6.62996 4.16498 6.81084 4.23783 6.99943 4.23783C7.18803 4.23783 7.36891 4.16498 7.50227 4.0353C7.63562 3.90563 7.71055 3.72976 7.71055 3.54637Z",
    fill: "#009CDE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.46617 10.2874H5.04395V6.83008H6.46617V10.2874Z",
    fill: "#009CDE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.95543 10.2874H7.5332V6.83008H8.95543V10.2874Z",
    fill: "#009CDE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6215 10.2874H10.0215V6.83008H11.6215V10.2874Z",
    fill: "#009CDE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7996 10.9805H2.19961C1.77526 10.9805 1.3683 11.1444 1.06824 11.4361C0.76818 11.7279 0.599609 12.1236 0.599609 12.5362V12.882C0.599609 13.1689 0.838543 13.4006 1.13294 13.4006H12.8663C13.0077 13.4006 13.1434 13.3459 13.2434 13.2487C13.3434 13.1514 13.3996 13.0195 13.3996 12.882V12.5362C13.3996 12.1236 13.231 11.7279 12.931 11.4361C12.6309 11.1444 12.224 10.9805 11.7996 10.9805Z",
    fill: "#009CDE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.97695 10.2874H2.37695V6.83008H3.97695V10.2874Z",
    fill: "#009CDE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBank);
export default __webpack_public_path__ + "static/media/bank.fa2e693ec97a9775f2ef49073ce4fcd1.svg";
export { ForwardRef as ReactComponent };